/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { EDIT_PRICE } from "../pages/ListedAssetDetail/graphql/edit-price.mutation"


const MODULE_NAME = "EditPriceService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class EditPriceService {
    name=MODULE_NAME;
    private static instance: EditPriceService;

    private constructor() {
        this.report();
    }
    static getInstance() {
        if (!this.instance) {
            this.instance = new EditPriceService();
        }
        return this.instance;
    }

   
    async editPrice(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `enable claim data in service`, data);
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: EDIT_PRICE,
                    variables:data,
                    
                    fetchPolicy: "no-cache",
                });
                log.success(MODULE_NAME, "ENABLE CLAIM: ", res);
                if (res) {
                    return res
                }
            }
        } catch (err) {
            return err
        }
    }
    private report() {
        log?.info(MODULE_NAME,`⚡⚡⚡===================⚡⚡⚡`);
        log?.info(MODULE_NAME,'Module Report');
        log?.info(MODULE_NAME, '⦿ Name: ' + this.name);
        log?.info(MODULE_NAME, `⚡⚡⚡===================⚡⚡⚡`);
    }
}
